import { UserpilotUserData } from './types';

export enum ActionTypes {
  USERPILOT_SCRIPT_LOADED = 'USERPILOT_SCRIPT_LOADED',
  USERPILOT_RELOADED = 'USERPILOT_RELOADED',
  USERPILOT_IDENTIFY = 'USERPILOT_IDENTIFY',
  USERPILOT_ANONYMOUS = 'USERPILOT_ANONYMOUS',
  USERPILOT_TRACKING_SENT = 'USERPILOT_TRACKING_SENT',
  USERPILOT_TRIGGER_SENT = 'USERPILOT_TRIGGER_SENT',
}

export type UserpilotScriptLoadedAction = {
  type: ActionTypes.USERPILOT_SCRIPT_LOADED;
};

export type UserpilotReloadedAction = {
  type: ActionTypes.USERPILOT_RELOADED;
};

export interface UserpilotIdentifyAction {
  type: ActionTypes.USERPILOT_IDENTIFY;
  user: UserpilotUserData;
}

export interface UserpilotAnonymousAction {
  type: ActionTypes.USERPILOT_ANONYMOUS;
}

export interface UserpilotTrackingSentAction {
  type: ActionTypes.USERPILOT_TRACKING_SENT;
  eventName: string;
  meta?: Record<string, unknown>;
}

export interface UserpilotTriggerSentAction {
  type: ActionTypes.USERPILOT_TRIGGER_SENT;
  checkListId: string;
}

export type UserpilotAction =
  | UserpilotScriptLoadedAction
  | UserpilotReloadedAction
  | UserpilotIdentifyAction
  | UserpilotAnonymousAction
  | UserpilotTrackingSentAction
  | UserpilotTriggerSentAction;
